import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { ptimProcessSteps } from "@/mocks/ptimData";

export default function PtimProcess() {
  return (
    <section id="process" className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / The 10-Week Testing Cycle
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
                From Hypothesis to Validated Decision
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                PTIM follows a rigorous four-phase methodology designed to produce investment-ready evidence and eliminate uncertainty before scale.
              </p>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden lg:block absolute top-8 left-[12.5%] right-[12.5%] h-0.5 bg-tie-teal/20" />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {ptimProcessSteps.map((step, index) => (
                <ScrollReveal key={step.phase} delay={index * 120}>
                  <div className="relative h-full">
                    <div className="flex items-center gap-3 mb-4 md:mb-5">
                      <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-tie-teal/10 border-2 border-tie-teal flex items-center justify-center shrink-0">
                        <span className="font-serif text-base md:text-lg font-bold text-tie-teal">
                          {index + 1}
                        </span>
                      </div>
                      <div className="lg:hidden flex-1 h-0.5 bg-tie-teal/15" />
                    </div>

                    <div className="p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300 h-full">
                      <div className="flex items-center justify-between mb-3">
                        <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">
                          {step.phase}
                        </span>
                        <span className="text-xs text-tie-text-muted px-2 py-1 rounded-full bg-tie-grey">
                          {step.week}
                        </span>
                      </div>
                      <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-2">
                        {step.title}
                      </h3>
                      <p className="text-sm text-tie-text-secondary leading-relaxed mb-4">
                        {step.description}
                      </p>
                      <div className="space-y-2">
                        {step.activities.map((activity) => (
                          <div
                            key={activity}
                            className="flex items-start gap-2 text-sm text-tie-text-secondary"
                          >
                            <span className="w-1.5 h-1.5 rounded-full bg-tie-teal shrink-0 mt-1.5" />
                            {activity}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}